module.exports = __webpack_public_path__ + "static/media/age-icon-dis.895664ad.svg";